module.exports = __webpack_public_path__ + "img/element-logo-small.a41e3270.svg";